/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-underscore-dangle */
import { useEffect, useRef } from 'react';
import styled from 'styled-components';

import { Ar } from '../../../components/Ar';

const Video = styled.video``;

const VideoCard = (props) => {
  const ref = useRef();
  const { peer, arOn } = props;
  useEffect(() => {
    const existingStream =
      peer._remoteStreams && peer._remoteStreams.length > 0
        ? peer._remoteStreams[0]
        : null;
    if (existingStream) {
      ref.current.srcObject = existingStream;
    }
    peer.on('stream', (stream) => {
      ref.current.srcObject = stream;
    });
    peer.on('track', (_track, _stream) => {});
  }, [peer]);

  return (
    <>
      <Video playsInline autoPlay ref={ref} />
      {arOn && <Ar refer={ref} />}
    </>
  );
};

export default VideoCard;
